export const state = {
    summary: {
        BUSINESS: 0,
        PAY_IN: 0,
        PAY_OUT: 0,
        PERSONAL: 0,
        COLLECT: 0,
        RECURRENT: 0
    },
};